<template>
  <div>
    <div class="login_bg">
      <div class="mobile_top">
        <span @click.prevent="onTout()">欢迎来到智污邦环保服务平台 </span>
        <span class="ml-30" @click.prevent="onSet()">帮助中心</span>
        <span class="ml-30" @click.prevent="onTout()">返回首页</span>
      </div>
      <div class="mobile_middle">
        <div class="moblie_conent">
          <div class="moblie_logo" @click.prevent="onTout()">
            <img class="mt-30" src="../assets/images/logo.jpg" alt="" />
          </div>
          <div v-if="type === 'login'" class="moblie_bater">
            <!-- <h4>登录</h4> -->
            <div class="login_box mt-10">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="账号登录" name="first">
                  <el-form
                    class="info_form"
                    :rules="loginRules"
                    :model="loginForm"
                    ref="loginForm"
                    label-width="80px"
                  >
                    <el-form-item
                      class="phone"
                      prop="mobile"
                      style="width: 100%"
                    >
                      <img
                        class="icon"
                        src="../assets/images/mobile.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        placeholder="请输入手机号码"
                        v-model="loginForm.mobile"
                        maxlength="11"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="phone" prop="password">
                      <img
                        class="icons"
                        src="../assets/images/password.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        type="password"
                        placeholder="请输入密码"
                        v-model="loginForm.password"
                      ></el-input>
                    </el-form-item>
                    <el-form-item style="width: 100%">
                      <el-button class="reset_login" @click="goLogin('loginForm')"
                        >确定登录</el-button
                      >
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
                <!--短信登录-->
                <el-tab-pane label="短信登录" name="second">
                  <el-form
                    class="info_forms"
                    :rules="rules"
                    :model="form"
                    label-width="80px"
                    ref="form"
                  >
                    <el-form-item prop="mobile" style="width: 100%">
                      <img
                        class="icon"
                        src="../assets/images/mobile.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        placeholder="请输入手机号码"
                        v-model="form.mobile"
                        maxlength="11"
                      ></el-input>

                      <!-- <el-button>发送验证码</el-button> -->
                    </el-form-item>
                    <el-form-item
                      class="code"
                      prop="imgCode"
                      style="width: 100%"
                    >
                      <img
                        class="icon"
                        src="../assets/images/security.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        placeholder="图形验证码"
                        v-model="form.imgCode"
                      ></el-input>
                      <img
                        class="graphic_code"
                        :src="imgUrl"
                        alt=""
                        @click.prevent="getCaptcha()"
                      />
                    </el-form-item>
                    <el-form-item
                      class="shortCode"
                      prop="smsCode"
                      style="width: 100%"
                    >
                      <el-input
                        class="myClass"
                        placeholder="短信验证码"
                        v-model="form.smsCode"
                      ></el-input>
                      <button   class="shortBtn" @click.prevent="onCode()">{{getCodeText}}</button>
                    </el-form-item>
                    <el-form-item style="width: 100%">
                      <el-button class="reset_login" @click="shortSubmit('form')">确定登录</el-button>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="retrieve fdc">
              <p class="underline" @click.prevent="onRetrieve()">找回密码</p>
              <p>
                <span>没有账号,</span>
                <span class="underline" @click.prevent="onRegister()"
                  >去注册</span
                >
              </p>
            </div>
            <div class="mt-20">
              <div class="other_fail">你可以用以下方式登录</div>
              <div class="other_icon">
                <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wx72a1afef42a9b317&redirect_uri=http%3A%2F%2Fwww.zhiwubang.cn%2Fapi%2Fzwb%2Fapp%2Fwechat%2Fcallback&response_type=code&scope=snsapi_login&state=20201130#wechat_redire">
                    <img class="WeChat" src="../assets/images/WeChat.png" alt="" />
                </a>
                <a href="https://api.weibo.com/oauth2/authorize?client_id=3813487040&response_type=code&redirect_uri=http%3a%2f%2fwww.zhiwubang.cn%2fapi%2fzwb%2fapp%2fweibo%2fcallback">
                <img
                  class="micro"
                  src="../assets/images/micro-blog.png"
                  alt=""
                />
                </a>
                 <a href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101920072&redirect_uri=http%3a%2f%2fwww.zhiwubang.cn%2fapi%2fzwb%2fapp%2fqq%2fcallback&state=20201130">
                   <img
                  class="qq"
                  src="../assets/images/QQ.png"
                  alt=""
                />
                 </a>

              </div>
            </div>
          </div>
        </div>
        <div class="moblie_text">
          中国·山东环境领域“互联网+环保”务实发展为本的共享平台
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getValidate ,smslogin,SmsCaptcha} from "@/api/user";
import {getToken} from '@/utils/auth'
import {getUsers} from "@/api/coment"
import { getUUID } from "@/utils/index";
export default {
  data() {
    //验证手机号规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      // const regMobile =/^1[34578]\d{9}$/;
       const regMobile =/^1\d{10}$/;
      if (regMobile.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return {
      form: {   //短信
        mobile: "",
        imgCode: "", //图形验证码
        smsCode:'',
      },
      loginForm: {  //密码
        mobile: "",
        password: "", //短信验证码
      },
      rules: {
        mobile: [{required: true,validator: checkMobile,trigger: "blur",}],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loginRules:{
        mobile: [{required: true,validator: checkMobile,trigger: "blur",}],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      activeName: "first",
      type: "login",
      redirect: undefined,
      imgUrl: "",
      uid: "",
      getCodeText: "获取验证码",
      getCodeisWaiting: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    let url = window.location.search;
    this.getCaptcha();
    if(url.indexOf('success')>-1){
      this.getUser();
    }

  window.addEventListener("keydown", this.keyDown);
    this.getCaptcha();
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
    window.removeEventListener('popstate', this.goBack, false); 
  },
  mounted(){
    if(window.history && window.history.pushState){
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }   
  },
  methods: {
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.goLogin("logform");
      }
    },
    setTimer() {
      let holdTime = 60;
      this.getCodeText = "重新获取(60)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          holdTime = 60;
          clearInterval(this.Timer);
          return;
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    handleClick(tab, event) {},
    //帮助中心
    onSet() {
      this.$router.push("/help_center");
    },
    //找回密码
    onRetrieve() {
      this.$router.push("/retrieve");
    },
    //注册
    onRegister() {
      this.$router.push("/register");
    },
    //首页
    onTout() {
      this.$router.replace("/");
    },

    //用户登录-账号密码
    goLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("user/login", {
              mobile: this.loginForm.mobile,
              password: this.loginForm.password,
            })
            .then((res) => {          
              console.log(res)  
              if(res.code == 0){
                this.$message({
                  message: "登录成功",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$router.push('/')
                    // this.$router.push({
                    //   path:this.redirect || '/'
                    // })
                    if (res.integral){
                      this.$message({
                        message: '登录成功！今日积分+'+res.integral,
                        type: 'success'
                      });
                    }
                  },
              });
              }
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    //获取用户信息
    getUser(){ 
      getUsers().then((res)=>{
      if(res.code == 0){     
        if(res.data.mobile == null  || res.data.mobile =="null" || res.data.mobile =='' ){
		    	this.$router.push('/mobile_phone')
            // this.$router.push({path:'/mobile_phone',query:{redirect_uri:this.redirect}})
        }else{
          // this.$router.push("/")
          this.$router.replace("/");
        }
       }
      }).catch((err)=>{})
    },
    //QQ登录
    doQqLogin() {
      const appId = "101920072";
      const redirect_uri = encodeURIComponent(
        `http://www.zhiwubang.cn/api/zwb/app/qq/callback`
      );
      window.open(
        `https://graph.qq.com/oauth2.0/authorize?client_id=${appId}&response_type=code&redirect_uri=${redirect_uri}`,
        "_blank"
      );
    },
    //发送验证码
    onCode() {   
      if (!this.form.mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (!this.form.imgCode) {
        this.$message({
          message: "请输入图形验证码",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.getCodeisWaiting) {
        return false;
      }
      let params = {
        mobile: this.form.mobile,
        uuid: this.uid,
        imgCode: this.form.imgCode,
      };
      this.setTimer();
      this.getCodeisWaiting = true;
      SmsCaptcha(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //短信登录
    shortSubmit(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          this.$store.dispatch("user/smslogin", {
              mobile:this.form.mobile,
              smsvaildCode:this.form.smsCode,
              uuid:this.uid,
              vaildCode:this.form.imgCode
            })
            .then((res) => {
              if(res.code == 0){
              this.$message({
                message: "登录成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.$router.push({
                    path:this.redirect || '/'
                  })
                },
              });
              }
            }).catch(() => {});
        }
      })
    },
    goBack(){
	   this.$router.replace('/');
   	}
  },
};
</script>
<style scoped>
.login_bg {
  background: url("../assets/images/login.jpg") no-repeat center/cover;
  min-height: 100vh;
}
.fcl {
  display: flex;
  justify-content: left;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.mb-100 {
  margin-bottom: 100px;
}
.underline {
  padding-bottom: 5px;
  text-decoration: underline;
  cursor: pointer;
}
.login_box >>> .el-tabs__nav-wrap::after {
  width: 0%;
}
.login_box >>> .el-tabs__item {
  font-size: 18px;
}
.login_box >>> .el-tabs__item.is-active {
  color: #333333;
  font-weight: bold;
}
.login_box >>> .el-tabs__item:hover {
  color: #333333;
}
.login_box >>> .el-tabs__active-bar {
  background-color: #333333;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
.info_form >>> .el-form-item__content {
  margin-left: 0px !important;
}
.info_form >>> input.el-input__inner {
  padding-left: 40px;
  font-size: 12px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
}
.info_form >>> .el-button {
  border: none;
}
.info_form >>> .el-select .el-input__inner {
  color: #333333;
}
.info_form >>> .el-input--suffix .el-input__inner {
  padding-left: 40px;
  font-size: 12px;
  color: #999999;
}
.info_form >>> .el-select .el-input__inner:focus {
  border-color: #eeeeee;
}
.info_form >>> .el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #eeeeee;
}
.info_form >>>.el-button--default:hover{
  color: #ffffff;
}
.info_forms >>> .el-form-item__content {
  margin-left: 0px !important;
}
.info_forms >>> .el-input__inner {
  height: 50px;
  padding-left: 40px;
  font-size: 12px;
  color: #999999;
}

.mobile_top {
  padding: 19px 22px;
}
.mobile_top span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.mobile_top span:hover {
  cursor: pointer;
}
.mobile_middle {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
}
.moblie_conent {
  /* width: 536px; */
  width: 436px;
  background:rgba(255, 255, 255, 0.8);
  /* opacity: 0.9; */
  /* opacity: 1; */
  margin-top: 20px;
}
.moblie_bater {
  margin: 32px 30px;
}
.moblie_conent h4 {
  font-size: 26px;
  font-family: PingFangSC;
  font-weight: bold;
  color: #333333;
}
.moblie_logo {
  display: flex;
  justify-content: center;
}

.moblie_logo img {
  width: 189px;
  height: 59px;
  cursor: pointer;
}
.phone {
  position: relative;
}
.code {
  position: relative;
}
/deep/.phone .el-button {
  position: absolute;
  height: 49px;
  top: 0;
  right: 0;
  color: #ffffff;
  width: 95px;
  background: #fb7103;
  border: none;
  font-size: 12px;
}
/deep/.phone .el-button:hover {
  color: #ffffff;
}
.icon {
  width: 24px;
  height: 26px;
  position: absolute;
  top: 12px;
  left: 10px;
  z-index: 100;
}
.icons {
  width: 32px;
  height: 34px;
  position: absolute;
  top: 7px;
  left: 5px;
  z-index: 100;
}

.reset_login {
  width: 100%;
  height: 50px;
  background: linear-gradient(104deg, #a2dc14, #69cc1e);
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.reset_login:hover {
  color: #ffffff;
}
.retrieve p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.other_fail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.other_icon {
  display: flex;
  justify-content: space-around;
  margin-top: 25px;
}
.other_icon img {
  width: 25px;
  height: 25px;
}
/* .WeChat {
  width: 25px;
  height: 21px;
}
.micro {
  width: 26px;
  height: 22px;
}
.qq {
  width: 20px;
  height: 24px;
} */
.define {
  height: 40px;
  background: linear-gradient(104deg, #a1db13, #69cb1d);
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  border: none;
  margin-top: 20px;
}
.underline {
  text-decoration: underline;
}
/**找回密码 */
.other_type p:nth-child(1) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.other_type p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.shortCode {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
  /* border: 1px solid #999999;
  opacity: 0.2; */
}
.next {
  width: 100%;
  height: 40px;
  background: linear-gradient(104deg, #a2dc14, #69cc1e);
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.not span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.moblie_text {
  /* width: 441px; */
  text-align: center;
  margin-top: 15px;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}
.el-button{
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue